module.exports = __webpack_public_path__ + "img/18.31667fd0.png";